var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommercialSeller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7562,
    cy: 13.2397,
    r: 12.5,
    fill: "#EE9D01"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1189_317",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 15,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.3396,
    y: 6.23975,
    width: 14,
    height: 14,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1189_317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.92297 18.4897V7.98975H15.0896V18.4897H11.5896V16.1564H10.423V18.4897H6.92297ZM8.08964 17.3231H9.25631V14.9897H12.7563V17.3231H13.923V9.15641H8.08964V17.3231ZM9.25631 13.8231H10.423V12.6564H9.25631V13.8231ZM9.25631 11.4897H10.423V10.3231H9.25631V11.4897ZM11.5896 13.8231H12.7563V12.6564H11.5896V13.8231ZM11.5896 11.4897H12.7563V10.3231H11.5896V11.4897ZM17.7146 15.2814L16.898 14.4647L17.5251 13.8231H15.673V12.6564H17.5251L16.898 12.0147L17.7146 11.1981L19.7563 13.2397L17.7146 15.2814Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialSeller);
export default __webpack_public_path__ + "static/media/commercial_seller.97a6ae51f43a4b9ef3d2f704ab9bb966.svg";
export { ForwardRef as ReactComponent };